import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { CaseService } from 'src/app/services/case.service';
import { StatsService } from 'src/app/services/stats.service';
import * as appData from '../shared/appData';

@Component({
  selector: 'stats2-chart',
  templateUrl: './case-stats2.component.html',
})

export class Stats2Component implements OnInit {
  @Input() chartData: any;

  reportCols: any[];
  chartOptions: any;  // options used to customize chart layout, etc
  chartSections: [];
  myChartSection: any;
  allSectionsData: any;   // contains the data for ALL sections
  timeframeChartOptions: any;   // timeframe chart options
  numberChartOptions: any;      // number chart options
  basicOptions: any;
  //
  pieChartData: any;
  dynoChartData: any;
  tfDiffData: any;    // timeframe chart-related data
  pieTFDiffData: any; // pie-chart for timeframe-related data
  numberData: any;    // number chart related data
  //
  chartType = 'bar';
  calcType = 'count';
  dsColors = ['red', 'black', 'green', 'blue', 'aqua', 'pink', 'violet', 'yellow', 'grey', '#1C39BB', '#FFE5B4', 'purple', '#0095B6', '#DE5D83', 'gold', '#0047AB', '#E0B0FF', 'magenta', 'aqua'];
  yearList: number[];
  myYear = 0;
  displayState: any = {
    workingDiv: false,
    gridDiv: false,
    chartDiv: false,
    chartDivDyno: false,
    returnDiv: true,
    tfDiffDiv: false
  };

  excelCols = appData.excelColList;  // column names used when exporting to Excel
  constructor(private utilService: UtilitiesService, private caseService: CaseService,
              private dictService: DictionaryService, private statsService: StatsService) {}

  ngOnInit() {
    this.utilService.doAudit('Charts init...');
    // localStorage.removeItem(this.cookieService.get('userName') + '-lastApplicant');
    this.myYear = (new Date()).getFullYear();
    this.populateYearList();
    this.reportCols = [
      {field: 'repDesc', header: 'Report Description'},
    ];
    this.chartOptions = {
      title: {
        display: true,
        text: 'Case Statistics',
        fontSize: 16
      },
      legend: {
        position: 'top'
      },
      options: {
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    };
    this.timeframeChartOptions = {
      title: {
        display: true,
        text: 'Resolution Timeframe Stats',
        fontSize: 16
      },
      legend: {
        position: 'top'
      }
    };
    this.numberChartOptions = {
      title: {
        display: true,
        text: 'Number Stats',
        fontSize: 16
      },
      legend: {
        position: 'top'
      }
    };
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
    // dkkdk
    this.basicOptions = {
      plugins: {
        legend: {
          labels: {
            color: textColor
          }
        }
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            color: textColorSecondary
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        },
        x: {
          ticks: {
            color: textColorSecondary
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        }
      }
    };
  // xkcxk
    this.chartData = {};
    this.pieChartData = {};
    this.tfDiffData = {};
    this.numberData = {};
    //
    const dicts = this.dictService.getDictionaries(); // get all dictionaries
    this.utilService.doAudit(dicts, 'dictionaries');
    //
    this.runCaseStatsReport();
    this.displayState.chartDiv = true;
    //
  }

  runCaseStatsReport() {
    if (!this.myYear) {
      alert('Please select a Roll Year!');
      return;
    }
    this.getReportDataFromView(this.myYear);
  }

  // get application/case data from the vwCaseListingInfo view
  getReportDataFromView(caseYear: number): void {
    const srcObj = {
      p0: '',
      p1: '',
      p2: ''
    };
    this.utilService.doAudit(srcObj, 'report search:');
    this.displayState.workingDiv = true;
    this.displayState.chartDiv = false;
    // get list of cases based on the Property Roll Year (NOT when they were filed, i.e. case # based)
    this.statsService.searchAppsByCaseYear(caseYear).subscribe(data => {
      this.utilService.doAudit(data, 'results from searchApplicationsByYear:');
      this.allSectionsData = data;
      this.chartOptions.title.text = 'Case Statistics for ' + caseYear + ' - by Status';
      // this.basicOptions.title.text = 'New Title for ' + caseYear + ' - by Stat';
      this.timeframeChartOptions.title.text = 'Resolution Timeframe Stats for ' + caseYear + ' (in days)';
      let caseObj: any = null;
      let closedFlag: boolean;
      let complexFlag: boolean;
      let startDate: Date;
      let endDate: Date;
      let numDays = 0;
      const caseTots = [0, 0, 0];  // 0pen, Closed  - added another item so the y-axis starts at zero!!
      const complexTots = [0, 0, 0]; // Complex, Regular  - added another item so the y-axis starts at zero!!
      const tfComplexTots: number[] = [];
      const tfRegularTots: number[] = [];
      //
      // timeframe related chart data
      const bucketList = ['0-30', '31-60', '61-90', '91-120', '121-150', '151-180', '181-210', '211-240', '241-270', '271-300', '301-330', '331-360', '361-999'];
      let bucket = 0;
      for (let x = 1; x < bucketList.length; x++) {
        tfComplexTots[x] = 0;
        tfRegularTots[x] = 0;
      }
      for (let i = 0; i < data.length; i++) {
        caseObj = data[i];
        closedFlag = caseObj.closedStatus ? caseObj.closedStatus : false;
        complexFlag = caseObj.complexCase ? caseObj.complexCase : false;
        // if (i > 5) { complexFlag = true; } // FOR TESTING ONLY!
        startDate = caseObj.dateReceived;
        endDate = caseObj.dateClosed ? caseObj.dateClosed : new Date();
        if (endDate) {
          numDays = this.calcDateDiff(startDate, endDate);
          bucket = Math.round(numDays / 30);
          if (bucket > (bucketList.length - 1)) {
            bucket = bucketList.length - 1; // if it took longer than a year, put it in the last bucket!
          }
        } else {
          numDays = 0;
          bucket = 0 ;
        }
        //
        if (closedFlag === false) {
          caseTots[0]++;  // open cases
        } else {
          caseTots[1]++;  // closed cases
        }
        if (complexFlag === true) {
          complexTots[0]++; // complex cases
          tfComplexTots[bucket]++;
        } else {
          complexTots[1]++; // regular cases
          tfRegularTots[bucket]++;
        }
      }
      const calcType = this.calcType;
      if (calcType === 'percent') {
        const cTot = complexTots[0] + complexTots[1];
        complexTots[0] = +(complexTots[0] /  cTot * 100).toPrecision(4);
        complexTots[1] = +(complexTots[1] / cTot * 100).toPrecision(4);
      }
      this.utilService.doAudit(caseTots, 'cases totals; open/closed');
      this.utilService.doAudit(complexTots, 'cases totals; regular/complex');
      this.chartSections = [];
      this.myChartSection = 1;
      const tDS = [
        {
          label: 'Case Types',
          data: complexTots,
          fill: false,
          backgroundColor: [
            'rgba(255, 159, 64, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(255, 205, 86, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(201, 203, 207, 0.2)'
          ],
          borderColor: [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
            'rgb(153, 102, 255)',
            'rgb(201, 203, 207)'
          ],
          borderWidth: 1
        }
      ];

      this.chartData = {
        labels: ['Complex', 'Regular'],
        datasets: tDS
      };

      this.dynoChartData = this.chartData;
      this.pieChartData = {
        labels: ['Complex', 'Regular'],
        datasets: [
          {
            label: 'Cases',
            data: complexTots,
            fill: false,
            borderColor: '#4bc0c0',
            backgroundColor: [
              'rgb(255, 99, 132)',
              'rgb(54, 162, 235)',
            ],
          },
        ]
      };
      this.utilService.doAudit(bucketList, 'days list:');
      this.utilService.doAudit(tfRegularTots, 'regular cases:');
      this.utilService.doAudit(tfComplexTots, 'complex cases:');
      const tDSTimeFrame = [
        {
          label: 'Complex Cases',
          data: tfComplexTots,
          fill: false,
          borderColor: '#4bc0c0',
          backgroundColor: '#42A5F5',
          borderWidth: 1
        },
        {
          label: 'Regular Cases',
          data: tfRegularTots,
          fill: false,
          borderColor: '#9CCC65',
          backgroundColor: 'darkgreen',
          borderWidth: 1
        }
      ];
      this.tfDiffData = {
        labels: bucketList,
        datasets: tDSTimeFrame
      };
      this.displayState.gridDiv = false;
      this.displayState.workingDiv = false;
      this.displayState.chartDiv = true;
      this.displayState.tfDiffDiv = true;
    });
  }
  onChangeType() {
    this.utilService.doAudit(this.chartType, 'changed type to:');
    if (this.chartType !== 'pie') {
      this.dynoChartData = Object.assign({}, this.chartData);
      this.tfDiffData = Object.assign({}, this.tfDiffData);
    } else {
      this.dynoChartData = Object.assign({}, this.pieChartData);
      this.tfDiffData = Object.assign({}, this.tfDiffData);
    }
  }

  onChangeCalc() {
    this.utilService.doAudit(this.calcType, 'changed calculation to:');
    this.runCaseStatsReport();
  }
  selectData(event) {
    this.utilService.doAudit(event, 'data selected:');
    this.utilService.doAudit(this.chartData.datasets[event.element._datasetIndex].data[event.element._index], 'item selected:');
  }

  selectTFData(event) {
    this.utilService.doAudit(event, 'data selected:');
    this.utilService.doAudit(this.tfDiffData.datasets[event.element._datasetIndex].data[event.element._index], 'item selected:');
  }
  populateYearList() {
    const curYr = new Date().getFullYear();
    const yrList = [];
    for (let yr = curYr; yr > (curYr - 20); yr--)
    {
      yrList.push(yr);
    }
    this.yearList = yrList;
  }

  exportExcel() {
    this.utilService.exportExcel2(this.allSectionsData, [this.excelCols], 'cases-for-' + this.myYear);
    // this.utilService.exportExcel2(this.valueDiffData, [['ID', 'City', 'ValueDiff']], 'value-diff-list');
    return;
  }
  // calculate the # of days between two dates
  calcDateDiff(fromDate: Date, thruDate: Date): number {
    this.utilService.doAudit('fromDate: ' + fromDate + '; thruDate: ' + thruDate);
    if (thruDate == null) { return 0; }
    const diffDays = this.utilService.convertDateToDays(thruDate) - this.utilService.convertDateToDays(fromDate);
    this.utilService.doAudit(diffDays, 'diffDays:');
    return diffDays;
  }
}
